// extracted by mini-css-extract-plugin
module.exports = {"container":"kA","productName":"lA","modal":"mA","dimensions":"nA","recipientEmail":"oA","lowStock":"pA"};